import * as React from 'react';
import { useCallback, useContext, useEffect, useState } from 'react';
import useMediaQuery from 'hooks/useMediaQuery';

export const AppContext = React.createContext({});

export default function AppProvider({ children }) {
  const isMobile = useMediaQuery('(max-width: 1024px)');
  const [menuIsOpen, setMenuIsOpen] = useState();
  const [efficiency, setEfficiency] = useState();
  const [lastUpdateInputFocus, setLastUpdateInputFocus] = useState(null);

  const setInputFocus = useCallback(
    () => setLastUpdateInputFocus(Date.now()),
    [],
  );

  useEffect(() => setMenuIsOpen(!isMobile), [isMobile]);

  return (
    <AppContext.Provider
      value={{
        menuIsOpen,
        setMenuIsOpen,
        efficiency,
        setEfficiency,
        getInputFocus: lastUpdateInputFocus,
        setInputFocus,
      }}
    >
      {children}
    </AppContext.Provider>
  );
}

export function useApp() {
  return useContext(AppContext);
}
